"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createForm = exports.FormCompiler = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Form = require("./Form.utils");

var _InputSelector = _interopRequireDefault(require("./InputSelector"));

var _FlexContainer = _interopRequireDefault(require("../FlexContainer"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FlexFormCompiler = (0, _styledComponents.default)(_FlexContainer.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: 100%;\n    padding: ", "; \n    @media(min-width: 740px){\n        padding:  ", ";\n    }\n"])), function (props) {
  return props.padding || '1rem';
}, function (props) {
  return props.padding || '1rem 3rem';
});

var FormCompiler = function FormCompiler(_ref) {
  var padding = _ref.padding,
      _ref$fields = _ref.fields,
      fields = _ref$fields === void 0 ? [] : _ref$fields,
      values = _ref.values,
      inputChangedHandler = _ref.inputChangedHandler,
      handleNext = _ref.handleNext,
      _ref$customValidation = _ref.customValidations,
      customValidations = _ref$customValidation === void 0 ? {} : _ref$customValidation,
      _ref$errorHandler = _ref.errorHandler,
      errorHandler = _ref$errorHandler === void 0 ? function () {} : _ref$errorHandler,
      _ref$errors = _ref.errors,
      errors = _ref$errors === void 0 ? {} : _ref$errors,
      postErrors = _ref.postErrors,
      postErrorHandler = _ref.postErrorHandler,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$buttonClickHandl = _ref.buttonClickHandlers,
      buttonClickHandlers = _ref$buttonClickHandl === void 0 ? [] : _ref$buttonClickHandl,
      cleanValues = _ref.cleanValues,
      formattingOptions = _ref.formattingOptions,
      sliderMax = _ref.sliderMax,
      companyLookUpInstructions = _ref.companyLookUpInstructions,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? {} : _ref$isLoading,
      _ref$noFocus = _ref.noFocus,
      noFocus = _ref$noFocus === void 0 ? false : _ref$noFocus,
      isEdit = _ref.isEdit,
      _ref$isReadOnlyForm = _ref.isReadOnlyForm,
      isReadOnlyForm = _ref$isReadOnlyForm === void 0 ? false : _ref$isReadOnlyForm,
      _ref$formOptions = _ref.formOptions,
      formOptions = _ref$formOptions === void 0 ? {} : _ref$formOptions,
      t = _ref.t;
  return _react.default.createElement(FlexFormCompiler, {
    column: true,
    padding: padding
  }, fields.map(function (field, index) {
    if (field.hasOwnProperty('paired')) {
      return _react.default.createElement(_FlexContainer.default, {
        key: index
      }, field.paired.map(function (input, i) {
        return _react.default.createElement(_FlexContainer.default, {
          column: true,
          key: i,
          style: input.style,
          margin: input.styles ? input.styles.margin : index === 0 && '0 16px 0 0',
          width: input.styles && input.styles.width || '100%'
        }, _react.default.createElement(_InputSelector.default, {
          customValidations: customValidations,
          isLoading: isLoading[input.id],
          fieldConfig: input,
          options: options,
          value: (0, _Form.getValue)(values, input),
          inputChangedHandler: inputChangedHandler,
          buttonClickHandlers: buttonClickHandlers,
          sliderMax: sliderMax,
          errors: errors[input.id],
          formattingOptions: formattingOptions,
          visible: input.visibility ? (0, _Form.determineVisibility)({
            values: values,
            input: input,
            inputChangedHandler: inputChangedHandler
          }) : true,
          errorHandler: errorHandler,
          cleanValues: cleanValues,
          formErrors: errors,
          companyLookUpInstructions: companyLookUpInstructions,
          validationDependency: input.validationDependency && _defineProperty({}, input.validationDependency, (0, _Form.getValue)(values, input.validationDependency)),
          disabled: isEdit && !input.editable || input.disabled && (0, _Form.isDisabled)(values, input.disabled) || isReadOnlyForm,
          extraValues: input.extraValues && (0, _Form.getExtraValues)(values, input.extraValues),
          handleNext: fields.length === index + 1 && i === 1 && handleNext,
          isFirstInput: index === 0 && i === 0,
          noFocus: noFocus,
          postErrors: postErrors === null || postErrors === void 0 ? void 0 : postErrors.find(function (e) {
            return e.field === input.id;
          }),
          postErrorHandler: postErrorHandler,
          t: t
        }));
      }));
    } else {
      return _react.default.createElement(_InputSelector.default, {
        key: field.id,
        customValidations: customValidations,
        fieldConfig: field,
        options: options,
        buttonClickHandlers: buttonClickHandlers,
        value: (0, _Form.getValue)(values, field),
        inputChangedHandler: inputChangedHandler,
        errors: errors[field.id],
        formErrors: errors,
        formattingOptions: formattingOptions,
        companyLookUpInstructions: companyLookUpInstructions,
        cleanValues: cleanValues,
        sliderMax: sliderMax,
        visible: field.visibility ? (0, _Form.determineVisibility)({
          values: values,
          input: field,
          inputChangedHandler: inputChangedHandler
        }) : true,
        errorHandler: errorHandler,
        validationDependency: field.validationDependency && _defineProperty({}, field.validationDependency, (0, _Form.getValue)(values, field.validationDependency)),
        disabled: isEdit && !field.editable || field.disabled && (0, _Form.isDisabled)(values, field.disabled) || isReadOnlyForm,
        extraValues: field.extraValues && (0, _Form.getExtraValues)(values, field.extraValues),
        handleNext: fields.length === index + 1 && handleNext,
        isFirstInput: index === 0,
        isLoading: isLoading[field.id],
        noFocus: noFocus,
        postErrors: postErrors === null || postErrors === void 0 ? void 0 : postErrors.find(function (e) {
          return e.field === field.id;
        }),
        postErrorHandler: postErrorHandler,
        formOptions: formOptions,
        t: t
      });
    }
  }));
};

exports.FormCompiler = FormCompiler;

var createForm = function createForm(_ref4) {
  var fields = _ref4.fields,
      _ref4$props = _ref4.props,
      buttonClickHandlers = _ref4$props.buttonClickHandlers,
      customValidations = _ref4$props.customValidations,
      errors = _ref4$props.errors,
      errorHandler = _ref4$props.errorHandler,
      inputChangedHandler = _ref4$props.inputChangedHandler,
      cleanValues = _ref4$props.cleanValues,
      isLoading = _ref4$props.isLoading,
      options = _ref4$props.options,
      values = _ref4$props.values,
      companyLookUpInstructions = _ref4$props.companyLookUpInstructions,
      sliderMax = _ref4$props.sliderMax,
      formattingOptions = _ref4$props.formattingOptions,
      handleNext = _ref4$props.handleNext,
      noFocus = _ref4$props.noFocus,
      isEdit = _ref4$props.isEdit,
      postErrors = _ref4$props.postErrors,
      postErrorHandler = _ref4$props.postErrorHandler,
      _ref4$props$isReadOnl = _ref4$props.isReadOnlyForm,
      isReadOnlyForm = _ref4$props$isReadOnl === void 0 ? false : _ref4$props$isReadOnl,
      _ref4$props$formOptio = _ref4$props.formOptions,
      formOptions = _ref4$props$formOptio === void 0 ? {} : _ref4$props$formOptio,
      t = _ref4$props.t;
  return _react.default.createElement(FormCompiler, {
    buttonClickHandlers: buttonClickHandlers,
    customValidations: customValidations,
    errors: errors,
    cleanValues: cleanValues,
    errorHandler: errorHandler,
    companyLookUpInstructions: companyLookUpInstructions,
    fields: fields,
    inputChangedHandler: inputChangedHandler,
    isLoading: isLoading,
    options: options,
    values: values,
    sliderMax: sliderMax,
    handleNext: handleNext,
    formattingOptions: formattingOptions,
    noFocus: noFocus,
    isEdit: isEdit,
    postErrors: postErrors,
    postErrorHandler: postErrorHandler,
    isReadOnlyForm: isReadOnlyForm,
    formOptions: formOptions,
    t: t
  });
};

exports.createForm = createForm;